import type { JSX, ReactNode, ComponentPropsWithoutRef } from 'react';
import { styled } from 'styled-components';
import type { ColorSchemeTypes } from '../ColorSchemeWrapper';
import { getColorScheme } from '../../private/helpers/getColorScheme';

type StyledMarkProps = {
  children: ReactNode;
  $colorScheme: ColorSchemeTypes;
};

const StyledMark = styled.mark<StyledMarkProps>`
  ${({ $colorScheme }) => getColorScheme($colorScheme)};
  background-color: var(--wui-color-bg-surface-tertiary);
  color: var(--wui-color-text);
  border-radius: var(--wui-border-radius-01);
  padding-inline: 0.1em;
  margin-inline: -0.1em;
`;

export type MarkProps = ComponentPropsWithoutRef<'div'> & {
  /** The content of the Mark component. */
  children: ReactNode;
  /** Sets the [color scheme](/docs/color-schemes) */
  colorScheme?: ColorSchemeTypes;
};

/**
 * Defines text that should be marked or highlighted.
 */
export const Mark = ({ children, colorScheme = 'inherit', ...props }: MarkProps): JSX.Element => (
  <StyledMark
    $colorScheme={colorScheme}
    {...props}
  >
    {children}
  </StyledMark>
);

Mark.displayName = 'Mark';
